/**
 * @generated SignedSource<<bef36c560734aa43c9c7e23b13f88e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowPricingGuidance_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item">;
  readonly " $fragmentType": "useShowPricingGuidance_item";
};
export type useShowPricingGuidance_item$key = {
  readonly " $data"?: useShowPricingGuidance_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowPricingGuidance_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowPricingGuidance_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "dc39e0b158ab23a312993df2d98b26a5";

export default node;
